module.exports = __webpack_public_path__ + "media/pl_pl_s2_Elzbieta.c08c4666.oga";